import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import {AuthService} from './auth.service';


@Injectable()
export class RestrictedRouterGuardService  {


    constructor(private authService: AuthService, private router: Router) {}


    canActivate():
     boolean | UrlTree {
        if (!this.authService.isRestricted) {
            return true;
        }
        return this.router.createUrlTree(['/']);
    }
}
